import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "@air/primitive-tooltip";
import { memo } from "react";
import { TABLE_ASSET_TITLE } from "~/constants/testIDs";
import { preventDefaultMouseEvent } from "~/utils/ClickUtils";
export const TableAssetTitle = /*#__PURE__*/ memo((param)=>{
    let { onClick, onCmdClick, title } = param;
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: title,
        side: "top",
        sideOffset: 4,
        children: /*#__PURE__*/ _jsx("button", {
            className: "block max-w-full truncate text-left text-14 font-medium text-grey-12 hover:underline",
            "data-testid": TABLE_ASSET_TITLE,
            onClick: (event)=>{
                if ((event.metaKey || event.ctrlKey) && !!onCmdClick) {
                    onCmdClick === null || onCmdClick === void 0 ? void 0 : onCmdClick("table-cell");
                } else {
                    onClick === null || onClick === void 0 ? void 0 : onClick("table-cell");
                }
            },
            onMouseDown: preventDefaultMouseEvent,
            children: title
        })
    });
});
TableAssetTitle.displayName = "TableAssetTitle";
